import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';

export type Response = {
	canDeleteIssues: boolean;
	isInlineCardCreateEnabled: boolean;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, rapidViewId: string): ObservableType<Response> =>
	fetchJson$(
		`${baseUrl}/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=${rapidViewId}`,
	);
